export enum BasisDatenFieldState {
  HIDDEN = 'hidden',
  READONLY = 'readonly',
}

interface BasisDatenConfiguration {
  gewicht?: BasisDatenFieldState;
  groesse?: BasisDatenFieldState;
  geschlecht?: BasisDatenFieldState;
}

export default BasisDatenConfiguration;
